import { PaymentIntegrationType } from '../../api';
import { useGetAccountAuthenticated } from '../../session/swr/useGetAccountAuthenticated';

// Card tokenization (saving a card on file and charging it later) is only implemented for
// Grow. The generator types payment_integration_type as required, but the backend leaves it
// null for accounts with no provider at all -- so always compare, never assume.
export const useIsGrowAccount = (): boolean => {
  const { account } = useGetAccountAuthenticated({});

  return account?.payment_integration_settings?.payment_integration_type === PaymentIntegrationType.GROW_PAYMENTS;
};
